var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoCollapsed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.162,
    height: 50.297,
    viewBox: "0 0 53.162 50.297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(22.123 9.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    d: "M0,0H12.057a0,0,0,0,1,0,0V19.607a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,19.607V0A0,0,0,0,1,0,0Z",
    transform: "translate(31.039 18.127) rotate(135)",
    fill: "#27bdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    d: "M0,0H12.057a0,0,0,0,1,0,0V25.81a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,25.81V0A0,0,0,0,1,0,0Z",
    transform: "translate(22.513 9.66) rotate(45)",
    fill: "#2ddfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M16314.922-1653.2l-8.436,8.5-.83-.829Z",
    transform: "translate(-16292.448 1662.86)",
    opacity: 0.333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    d: "M0,0H12.057a0,0,0,0,1,0,0V19.607a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,19.607V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 22.572) rotate(-45)",
    fill: "#025186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    d: "M0,0H12.057a0,0,0,0,1,0,0V25.81a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,25.81V0A0,0,0,0,1,0,0Z",
    transform: "translate(8.525 31.039) rotate(-135)",
    fill: "#0058ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M16305.656-1644.7l8.438-8.5.828.829Z",
    transform: "translate(-16297.014 1675.736)",
    opacity: 0.333
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCollapsed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_collapsed.90861f6e3f8f1060d6b33273466d74be.svg";